import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import { useAppText } from "src/commun/composants/AppText";

export type VerificationMailFormProps = {
  pageSuivante: (data: any) => void;
};


const CodeMailFinalisation = ({ pageSuivante }: VerificationMailFormProps) => {

  const { tString } = useAppText();
  const [value] = useFinalisation();
    
  return (
    <AppRow>
      <AppCol>
        {tString("compte.mon.profile.email.code.recu.valide")}
      </AppCol>
      <AppCol>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={() => pageSuivante(value.etapes[0].data)}
          value={tString("action.continuer")}
        />
      </AppCol>
    </AppRow>
  );

};

export default CodeMailFinalisation;